import {Component, Input, OnInit} from '@angular/core';
import {HttpServiceFacade} from 'src/app/shared/http.service.facade';
import {finalize, takeUntil} from 'rxjs/operators';
import {CustomerDTO} from '../../model/customer.model';
import {Subject} from 'rxjs';
import {FormBuilder, FormControl} from '@angular/forms';
import {AlertPopupService} from "../../../services/alert.popup.service";
import {CustomersService} from "../../../services/customers.service";
import {UserDataStoreService} from "../../service/user-data-store.service";
import {Pageable, PageRequest} from "../../model/pageable";
import {BaseForm} from "../../base-form";


@Component({
    selector: 'app-customer-picker',
    templateUrl: './customer-picker.component.html',
    styleUrls: ['./customer-picker.component.scss']
})
export class CustomerPickerComponent extends BaseForm implements OnInit{

    customerControl!: FormControl
    @Input() editable: boolean = true;

    private ngUnsubscribe: Subject<void> = new Subject();
    isLoadingCustomerCandidates = true;
    customers!: CustomerDTO[];

    constructor(
        private formBuilder: FormBuilder,
        protected override alertPopupService: AlertPopupService,
        public httpServiceFacade: HttpServiceFacade,
        public customerService: CustomersService,
        public userDataStoreService: UserDataStoreService,
    ) {
        super(httpServiceFacade, alertPopupService)
        this.customerControl = this.formBuilder.control('')

        this.controlGroup = this.formBuilder.group({
            customer: this.customerControl
        });
    }

    override ngOnInit() {
        this.loadCustomers();
    }

    loadCustomers() {
        // Load customers if user has an admin role
        if (this.userDataStoreService.isAdmin() || this.userDataStoreService.isSuperAdmin()) {
            this.customerService.getCustomers(new PageRequest(0, 1000))
                .pipe(
                    finalize(() => this.isLoadingCustomerCandidates = false),
                    takeUntil(this.ngUnsubscribe))
                .subscribe((data: Pageable<CustomerDTO>) => {
                    if (data.content) {
                        this.customers = data.content;
                        this.customerControl.setValue(null);
                        this.userDataStoreService.setCustomer({id: -1} as CustomerDTO);
                    }
                    else
                        this.customers = [];
                })
        }
    }

    onCustomerSelected(event: any): void {
        const selectedCustomerId = event.value;

        if (selectedCustomerId === null) {
            // Set customer ID to -1 when "None" is selected
            this.userDataStoreService.setCustomer({ id: -1 } as CustomerDTO);
        } else {
            // Otherwise, set the selected customer
            const selectedCustomer = this.customers.find(customer => customer.id === selectedCustomerId)!;
            this.userDataStoreService.setCustomer(selectedCustomer);
        }
    }

    onClearClick(): void {
        this.customerControl.setValue(null); // Clear the selection
        this.userDataStoreService.setCustomer({ id: -1 } as CustomerDTO);
    }

    override ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
}
